export default "__VITE_ASSET__oSNwGmwu__"